// extracted by mini-css-extract-plugin
export var header = "_vs-1";
export var maskBottom = "_vs-6";
export var maskMiddle = "_vs-7";
export var maskTop = "_vs-5";
export var root = "_vs-0";
export var scrollDownButton = "_vs-3";
export var scrollDownButtonHidden = "_vs-4";
export var viewport = "_vs-2";